var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Modifier from 'ember-modifier';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import { capitalize } from '@ember/string';
import { registerDestructor } from '@ember/destroyable';
function cleanup(instance) {
  let {
    el,
    scheduleResize
  } = instance;
  el.removeEventListener('input', scheduleResize);
}
let AutoresizeModifier = (_class = class AutoresizeModifier extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "listener", null);
  }
  resize() {
    let {
      el: element
    } = this;
    let dimension = this.named.mode ?? 'height';
    let previousWrap = element.style.whiteSpace;
    if (dimension === 'width') {
      // disable default wrapping
      element.style.whiteSpace = 'pre';
    }
    let capitalizeDimension = capitalize(dimension);

    // height / width must be calculated independently from height / width previously enforced
    element.style[dimension] = 'auto';
    let isBorderBox = window.getComputedStyle(element).boxSizing === 'border-box';
    let requiredDimension = element[`scroll${capitalizeDimension}`];
    if (isBorderBox) {
      // borders must be added on top of scrollHeight / scrollWidth if box-sizing is border-box
      let borderDimension = element[`offset${capitalizeDimension}`] - element[`client${capitalizeDimension}`];
      requiredDimension += borderDimension;
    }
    element.style[dimension] = `${requiredDimension}px`;
    element.style.whiteSpace = previousWrap;
  }
  scheduleResize() {
    scheduleOnce('afterRender', this, 'resize');
  }
  modify(element, [value], named) {
    this.el = element;
    this.named = named;
    this.value = value;
    if (this.listener === null) {
      this.listener = this.el.addEventListener('input', this.scheduleResize);
    }
    this.scheduleResize();
    registerDestructor(this, cleanup);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "resize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scheduleResize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "scheduleResize"), _class.prototype)), _class);
export { AutoresizeModifier as default };